import React from "react";
import Search from "./Components/Search";
import Pagination from "./Components/Pagination";
import Stories from "./Components/Stories";
import "./App.css";

const App = () => {
  return (
    <div>
      <Search />
      <Pagination />
      <Stories />
    </div>
  );
};

export default App;
